<template>
  <div class="module-selector">
    <div class="panel panel-info">
      <div class="panel-heading">
        <div class="form-inline">
          <div v-for="(t, i) in targets" :key="`target-${i}`"
               class="form-group">
            <div v-if="multi">
              <sui-checkbox v-model="selection[t[styleField]]"
                            v-show="!locked || selection[t[styleField]]"
                            :type="t[styleField]" size="sm"
                            :disabled="locked">
                {{ t[labelField] }}
              </sui-checkbox>
            </div>
            <div v-else>
              <btn :class="`btn btn-${t[styleField]}`" @click="selectOne(t)"
                   :disabled="locked">
                {{ t[labelField] }}
              </btn>
            </div>
          </div>
          <div v-if="multi" class="form-group">
            <btn type="default" @click="selectAll"
                 v-show="!locked">
              Tous
            </btn>
          </div>
          <div v-if="multi" class="form-group">
            <btn type="info" @click="apply"
                 v-show="!locked"
                 :disabled="noneSelected">
              Appliquer
            </btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import suiCheckbox from '@/sui/components/checkbox'

export default {
  name: 'module-selector',

  props: {
    targets: {
      type: Array,
      default: () => []
    },

    labelField: {
      type: String,
      default: 'name'
    },

    styleField: {
      type: String,
      default: 'style'
    },

    multi: {
      type: Boolean,
      default: false
    },

    locked: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    const selection = {}
    for (let i = 0; i !== this.targets.length; ++i) {
      const t = this.targets[i]
      selection[t[this.styleField]] = false
    }
    return {
      selection
    }
  },

  watch: {
    targets: function (value) {
      for (let i = 0; i !== value.length; ++i) {
        const t = value[i]
        const f = t[this.styleField]
        if (this.selection[f] == null) {
          this.$set(this.selection, f, false)
        }
      }
    }
  },

  methods: {
    selectAll: function (s) {
      for (let key in this.selection) {
        if (!this.selection[key]) {
          this.$set(this.selection, key, true)
        }
      }
    },

    selectOne: function (s) {
      this.$emit('selected', s)
    },

    apply: function () {
      const result = []
      for (let key in this.selection) {
        if (this.selection[key]) {
          result.push(key)
        }
      }
      this.$emit('selected', result)
    }
  },

  computed: {
    noneSelected: function () {
      for (let key in this.selection) {
        if (this.selection[key]) {
          return false
        }
      }
      return true
    }
  },

  components: {
    'sui-checkbox': suiCheckbox
  }
}
</script>
<style scoped lang="less">
@import '~variables';

</style>
